export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";



// WEBPACK FOOTER //
// ./src/system/store/site/types.js